import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import {
  Wrapper,
  TourContainer,
  TourContent,
  BackBtn,
} from './TourDetail.styles';
import backIcon from '../../assets/images/back-arrow.svg';
import { Link } from 'react-router-dom';
import Page from '../../components/Page/Page';
import Wave from '../../components/Wave/Wave';
import { tours } from '../../constants/tours';

const TourDetail = () => {
  const { name } = useParams();

  const [data, setData] = useState(null);

  useEffect(() => {
    const tour = tours.filter((tour) => tour.id === name);
    setData(tour[0]);
  }, [name]);

  return (
    <Page borderTop={false} backBtn={false}>
      <Wave />

      <Wrapper>
        {data && (
          <TourContainer>
            <TourContent src={`${data.url}&title=0&play=1&help=0&vr=0`} />
          </TourContainer>
        )}
      </Wrapper>
      <Link to='/rundgang-hausboote'>
        <BackBtn src={backIcon} />
      </Link>
    </Page>
  );
};

export default TourDetail;
